/**
 * terms Translations
 * Page-specific translations for terms
 */

import enTranslations from './en.json';
import deTranslations from './de.json';
import esTranslations from './es.json';
import noTranslations from './no.json';
import frTranslations from './fr.json';
import itTranslations from './it.json';
import ptTranslations from './pt.json';
import nlTranslations from './nl.json';
import plTranslations from './pl.json';
import svTranslations from './sv.json';
import daTranslations from './da.json';
import fiTranslations from './fi.json';
import csTranslations from './cs.json';
import huTranslations from './hu.json';
import roTranslations from './ro.json';
import idTranslations from './id.json';
// Note: cs, da, de, en, es, fi, hu, no, fr, it, pt, nl, pl, ro, sv, and id translations are available
// Other languages will fall back to English
import elTranslations from './el.json';

const translations = {
  en: enTranslations,
  de: deTranslations,
  es: esTranslations,
  no: noTranslations,
  fr: frTranslations,
  it: itTranslations,
  pt: ptTranslations,
  nl: nlTranslations,
  pl: plTranslations,
  sv: svTranslations,
  da: daTranslations,
  fi: fiTranslations,
  cs: csTranslations,
  hu: huTranslations,
  ro: roTranslations,
  el: elTranslations,
  id: idTranslations
};
export default translations;
